(function() {
  var originalFetch = window.fetch;
  window.fetch = function(url, options) {
    if (typeof url === 'string' && url.includes('/cart/add')) {
      return originalFetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      }).then(function() {
        return originalFetch(url, options);
      }).then(function(response) {
        setTimeout(function() {
          window.location.href = '/checkout';
        }, 100);
        return response;
      });
    }
    return originalFetch(url, options);
  };
})();